import { PagePending } from "@/components/ui/PagePending";
import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/members/$memberId/transactions")({
  pendingComponent: PagePending,
  beforeLoad: () => ({
    breadcrumb: "Transactions",
  }),
  component: lazyRouteComponent(() => import("./+TransactionsPage")),
  head: () => ({ meta: seo({ title: "Member Transactions" }) }),
});
